import { createRouter, createWebHistory } from 'vue-router'
import Home from '@/views/general/Home.vue'
import Login from '@/views/general/Login.vue'
import Register from '@/views/general/Register.vue'
import AuthorRegistration from '@/views/general/AuthorRegistration.vue'
import Langganan from '@/views/general/Langganan.vue'
import MyRead from '@/views/accounts/MyRead.vue'
import Profile from '@/views/accounts/Profile.vue'
import Collections from '@/views/books/Collections.vue'
import ReadingNotes from '@/views/reading/ReadingNotes.vue'
import Notifications from '@/views/Notifications.vue'
import PaymentHistory from '@/views/payments/PaymentHistory.vue'
import PendingPayment from '@/views/payments/PendingPayment.vue'
import PaymentError from '@/views/payments/PaymentError.vue'
import PaymentSuccess from '@/views/payments/PaymentSuccess.vue'
import HelpCenter from '@/views/general/HelpCenter.vue'
import ReadingStats from '@/views/reading/ReadingStats.vue'

import Page from '@/views/general/Page.vue'
import CategoryPage from '@/views/books/CategoryPage.vue'
import BookDetail from '@/views/books/BookDetail.vue'
import Chapter from '@/views/books/Chapter.vue'
import CreateChapter from '@/views/books/CreateChapter.vue'
import EditChapter from '@/views/books/EditChapter.vue'
import ContactUs from '@/views/ContactUs.vue'

// New Karyaku Menu Components
import MyBooks from '@/views/accounts/MyBooks.vue'
import MyEarnings from '@/views/accounts/MyEarnings.vue'
import MyInvoices from '@/views/accounts/MyInvoices.vue'
import MyAccounts from '@/views/accounts/MyAccounts.vue'

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/register-author',
    name: 'AuthorRegistration',
    component: AuthorRegistration
  },
  {
    path: '/langganan',
    name: 'Langganan',
    component: Langganan,
    meta: { requiresAuth: true }
  },
  {
    path: '/contact',
    name: 'Contact',
    component: ContactUs,
  },
  { path: '/:slug', component: Page },
  {
    path: '/categories-all',
    name: 'CategoriesAll',
    component: () => import('@/views/books/CategoriesAll.vue')
  },
  {
    path: '/my-reads',
    name: 'MyRead',
    component: MyRead,
    meta: { requiresAuth: true } // Protect the route
  },
  { path: '/categories/:id', component: CategoryPage },
  { 
    path: '/book/:slug', 
    name: 'BookDetail',
    component: BookDetail 
  },
  // Rute untuk membuat chapter baru (pindahkan ke atas untuk prioritas lebih tinggi)
  {
    path: "/books/:bookSlug/create-chapter/:bookId",
    name: "CreateChapter",
    component: CreateChapter,
    meta: { requiresAuth: true },
    props: true
  },
  // Rute untuk mengedit chapter (pindahkan ke atas untuk prioritas lebih tinggi)
  {
    path: "/books/:bookSlug/chapters/:chapterSlug/edit",
    name: "ChapterEditor", // Ganti nama route agar tidak konflik
    component: EditChapter,
    meta: { requiresAuth: true }
  },
  // Rute untuk melihat chapter (tetap dengan nama yang sama)
  {
    path: "/books/:bookSlug/chapters/:chapterSlug",
    name: "Chapter",
    component: Chapter,
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: { requiresAuth: true }
  },
  {
    path: '/collections',
    name: 'Collections',
    component: Collections,
    meta: { requiresAuth: true }
  },
  {
    path: '/reading-notes',
    name: 'ReadingNotes',
    component: ReadingNotes,
    meta: { requiresAuth: true }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment-history',
    name: 'PaymentHistory',
    component: PaymentHistory,
    meta: { requiresAuth: true }
  },
  {
    path: '/help-center',
    name: 'HelpCenter',
    component: HelpCenter,
    meta: { requiresAuth: true }
  },
  {
    path: '/reading-stats',
    name: 'ReadingStats',
    component: ReadingStats,
    meta: { requiresAuth: true }
  },
  // New Karyaku Menu Routes
  {
    path: '/my-books',
    name: 'MyBooks',
    component: MyBooks,
    meta: { requiresAuth: true }
  },
  {
    path: '/books/create',
    name: 'CreateBook',
    component: () => import('@/components/CreateBook.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/books/:bookSlug/edit/:bookId',
    name: 'EditBook',
    component: () => import('@/components/CreateBook.vue'),
    meta: { requiresAuth: true },
    props: true
  },
  {
    path: '/my-earnings',
    name: 'MyEarnings',
    component: MyEarnings,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-invoices',
    name: 'MyInvoices',
    component: MyInvoices,
    meta: { requiresAuth: true }
  },
  {
    path: '/my-accounts',
    name: 'MyAccounts',
    component: MyAccounts,
    meta: { requiresAuth: true }
  },
  // New routes to add
  {
    path: '/referral-code',
    name: 'ReferralCode',
    component: () => import('@/views/referral/ReferralCode.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/referral-list',
    name: 'ReferralList',
    component: () => import('@/views/referral/ReferralList.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/bank-accounts',
    name: 'BankAccounts',
    component: () => import('@/views/payments/BankAccounts.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/payment/pending',
    name: 'PendingPayment',
    component: PendingPayment,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment/error',
    name: 'PaymentError',
    component: PaymentError,
    meta: { requiresAuth: true }
  },
  {
    path: '/payment/success',
    name: 'PaymentSuccess',
    component: PaymentSuccess,
    meta: { requiresAuth: true }
  },
  {
    path: '/withdrawal-history',
    name: 'WithdrawalHistory',
    component: () => import('@/views/payments/PaymentHistory.vue'),
    meta: { requiresAuth: true }
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// Navigation guard for routes that require authentication
router.beforeEach(async (to, from, next) => {
  // Dynamically import the auth store to avoid circular dependency
  const { useAuthStore } = await import('./stores/auth');
  const authStore = useAuthStore();
  const isAuthenticated = authStore.isLoggedIn;
  
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isAuthenticated) {
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router
